import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

import {TenantAccountActivityStore} from 'src/app/services/tenant/tenant-account-activity.signal-store';
import {DisplayUserLogoComponent} from 'src/app/modules/design-system/display-user-logo/display-user-logo.component';

/** Colleagues drawn in the header stack; the others make up its "+X" disc. */
const STACK_SIZE = 3;
/** Colleagues listed in the hover panel; the others make up its "+X" line. */
const PANEL_SIZE = 6;

/**
 * KAB-2397 — Header avatars of the colleagues seen over the last 30 days (the user's own status is the menu's profile
 * dot); hovering lists them with their status (Figma Ready 16538:30492, hover 16538:30940).
 */
@Component({
	selector: 'app-members-activity',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslateModule, DisplayUserLogoComponent],
	templateUrl: './members-activity.component.html',
	styleUrl: './members-activity.component.scss'
})
export class MembersActivityComponent {

	protected readonly store = inject(TenantAccountActivityStore);

	/** The latest colleagues seen (the engine sorts them). The user alone: no stack, hence no panel either. */
	protected readonly panelMembers = computed(() => this.colleagues().slice(0, PANEL_SIZE));
	protected readonly panelHiddenCount = computed(() => Math.max(0, this.colleagues().length - PANEL_SIZE));
	protected readonly hiddenLabelKey = computed(() => this.panelHiddenCount() > 1 ? 'menu.activity.others' : 'menu.activity.other');

	/** The first of them drawn right to left, so that the latest, and its status dot, lies on top — under the "+X"
	 * when colleagues are left out. */
	protected readonly stack = computed(() => this.colleagues().slice(0, STACK_SIZE).reverse());
	protected readonly stackHiddenCount = computed(() => Math.max(0, this.colleagues().length - STACK_SIZE));

	private readonly colleagues = computed(() => this.store.members().filter(member => !member.isSelf));
}
